import axios from 'axios'
export default axios.create({
  baseURL: process.env.REACT_APP_SAS,
  withXSRFToken: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

export const axiosPrivateSAI = axios.create({
  baseURL: process.env.REACT_APP_SAS,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
})
